import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import MoonStarsSvg from '../../../shared/UI/moonStarsSvg';
import { UpdateSectorAccommodation } from '../../../../actions/booking';
import { GetSectorHotel } from '../../../../actions/hotel';
import { pluralHelper } from '../../../../helpers/stringutils';
import { withApollo } from 'react-apollo';
import { get } from '../../../../helpers/objectHelper';
import { ISOCurrencyCovert } from '../../../../helpers/locationHelper';
import SpinnerText from '../../../shared/UI/spinner';
import Spinner from '../../../shared/UI/button-spinner';
import { calculateBedOrRoomTotal, reservationData } from '../../../../helpers/accommodationHelper';

class AccommodationPanel extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            accommodationType:"", //hostel / hotel / none
            hotelOption:"",
            hotelMessage:"",
            hostelOption:"",
            hostelMessage:""
        }
        this.onAccommodationChange = this.onAccommodationChange.bind(this);
        this.handleHotelAccommodation = this.handleHotelAccommodation.bind(this);
        this.handleHostelAccommodation = this.handleHostelAccommodation.bind(this);
    }

   componentDidMount(){

        const { client, currentBooking:{uuid, filteredItinerary}, currentStop } = this.props;
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);
    
        //Pre-select room type from reservations
        this.selectFromReservation();

        //Get hotel accomodation data
        GetSectorHotel(client, uuid, _sectorId);
    }


    componentDidUpdate(prevProps, prevState){

        const { client, currentBooking:{uuid, filteredItinerary}, currentStop } = this.props;
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);

        if(currentStop !== prevProps.currentStop){
            this.selectFromReservation();
            GetSectorHotel(client, uuid, _sectorId);
        }
     }

     selectFromReservation(){
        const { data, currentBooking:{passengers}, removeMap, updateMap } = this.props;
        const _hasReservations = get(['accommodation', 'reservations'], data, []);

        if(_hasReservations.length === 0){
            this.setState({accommodationType:"none", hotelOption:"", hotelMessage:"", hostelOption:"", hostelMessage:""});
            removeMap(true, true);
        }else{
             
            const { propertyType, roomType, currency, total, type, roomCode } = _hasReservations[0];

            if(propertyType.toLowerCase() === 'hostel'){

                this.setState({
                    accommodationType:propertyType.toLowerCase(),
                    hostelOption:roomCode, 
                    hostelMessage:`${roomType} - ${ISOCurrencyCovert(currency).props.children}${type === "dorm" ? (passengers.length * total).toFixed(2) : total.toFixed(2)}`,
                    hotelOption:"", 
                    hotelMessage:""
                });
                removeMap(true, true);

            }else{
                this.setState({
                    accommodationType:propertyType.toLowerCase(), 
                    hotelOption:roomCode !== null ? roomCode : "",
                    hotelMessage:`${roomType} - ${ISOCurrencyCovert(currency).props.children}${total}`,
                    hostelOption:"", 
                    hostelMessage:""
                });
                updateMap(true, false);
            }
            
        }
     }

    onAccommodationChange(propertyType){

        const { client, currentStop, currentBooking:{ filteredItinerary, iso_currency }, isLoading, removeMap } = this.props;
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);
        
        if(propertyType === "none"){
            this.setState({accommodationType:"none", hotelOption:"", hotelMessage:"", hostelOption:"", hostelMessage:""});
            if(!isLoading){
                UpdateSectorAccommodation(client, _sectorId, "none", "none", "none", "none", iso_currency);
                removeMap(true, true);
            } 
        }  
    }

    handleHostelAccommodation(e){

        const { client, currentStop, currentBooking:{ filteredItinerary, iso_currency, passengers }, isLoading, data, removeMap } = this.props;
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);
        const _hostelAccommodation = get(["accommodation", "options", "hostel"], data, "");

        this.setState({hostelOption:e.target[e.target.selectedIndex].getAttribute('data-roomcode'), accommodationType:"hostel", hostelMessage:"", hotelOption:"", hotelMessage:""});

        if(!isLoading){ 

            removeMap(true, true);

            UpdateSectorAccommodation(
                client, 
                _sectorId, 
                _hostelAccommodation.propertyType.toLowerCase(),
                _hostelAccommodation.type,
                e.target[e.target.selectedIndex].getAttribute('data-type'), 
                e.target[e.target.selectedIndex].getAttribute('data-roomcode'),
                iso_currency
            ).then(() => {
                
                const { roomType, currency, total, type }  = get(['accommodation', 'reservations', 0], this.props.currentBooking.filteredItinerary[currentStop], "");
                this.setState({hostelMessage:`${roomType} - ${ISOCurrencyCovert(currency).props.children}${type === "dorm" ? (passengers.length * total).toFixed(2) : total}`});
         
            })
            
        }
    }


    handleHotelAccommodation(e){
        
        const { client, currentStop, currentBooking:{ filteredItinerary, iso_currency }, isLoading, hotel, updateMap } = this.props;
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);

        this.setState({hotelOption:e.target[e.target.selectedIndex].getAttribute('data-roomcode'), accommodationType:"hotel", hotelMessage:"", hostelOption:"", hostelMessage:""});
   
        if(!isLoading){ 

            UpdateSectorAccommodation(
                client, 
                _sectorId, 
                hotel.propertyType,
                hotel.type,
                e.target[e.target.selectedIndex].getAttribute('data-roomtype'), 
                e.target[e.target.selectedIndex].getAttribute('data-roomcode'),
                iso_currency
            ).then(() => {
                
                const { roomType, currency, total }  = get(['accommodation', 'reservations', 0], this.props.currentBooking.filteredItinerary[currentStop], "");
                this.setState({hotelMessage:`${roomType} - ${ISOCurrencyCovert(currency).props.children}${total}`});
                updateMap(true, false);
            })
            
        }
    }

    render(){
        
        const { hotelOption, hotelMessage, accommodationType, hostelOption, hostelMessage } = this.state;
        const { data, currentBooking:{ iso_currency, passengers }, hotel, hotelLoading } = this.props;
        const { nights, pricePerNight, dormOrRoomText, dormOrRoomAmount, rooms } = reservationData(data, passengers.length);

        const accommodation = {
            hostelName: get(["accommodation", "options", "hostel", "name"], data, ""),
            hostelRooms: get(["accommodation", "options", "hostel", "rooms"], data, []),
            hotelName: get(["name"], hotel, ""),
            hotelRooms: get(["rooms"], hotel, [])
        }
        
        return (
            <Fragment>
                  <div className="accommodation-box rounded-corners margin-b-20">
                    <div className="yes-accommodation">
                        <p className="bold margin-b-30"><MoonStarsSvg clazz="mr2"/>Book {nights} Nights Accommodation</p>
                      
                        <p className="bold mb1">Hostel</p>
                        <p className="mb1 f-size-14">{accommodation.hostelName}</p>

                        <div className="select-wrapper">
                            <div className={`busabout-radio radio margin-b-10 arrow`}>
                                <input
                                    id={`hostelAccommodationCard`}
                                    name={`hostelAccommodationCard`}
                                    type="radio"
                                    value="hostel"
                                    checked={accommodationType === "hostel"}
                                    readOnly
                                />
                                <label htmlFor={`hotelAccommodationCard`} className="radio-label">{hostelOption === "" ? 'Select hostel room' : hostelMessage }</label>
                            </div> 

                            <form className="form round-corners white-background">
                                <select 
                                        name="hostel_accommodation"
                                        value={hostelOption} 
                                        onChange={this.handleHostelAccommodation}
                                        className={`busabout-selectdropdown x-small outline round-corners ${accommodationType === "hostel" ? 'hostel' : ''}`}> 
                                    >
                                    <option value="" disabled>Select hostel room</option>

                                    { accommodation.hostelRooms.map(item => (
                                        <option 
                                            key={item.roomCode} 
                                            value={item.roomCode} 
                                            data-roomcode={item.roomCode} 
                                            data-roomtype={item.roomType}
                                            data-type={item.type}
                                            data-propertytype={item.propertyType} 
                                            data-message={`${item.description} - ${ISOCurrencyCovert(iso_currency).props.children}${calculateBedOrRoomTotal(item.type, passengers.length, item.price, data.nights)}`}>
                                            {item.description} - {ISOCurrencyCovert(iso_currency).props.children}{calculateBedOrRoomTotal(item.type, passengers.length, item.price, data.nights)}
                                        </option>)
                                    )
                                    }
                                </select>
                            </form>

                            {   
                                (accommodationType === 'hostel' && hostelMessage !== "") && (
                                    <p className="green-text right-align f-size-14 medium">
                                        {ISOCurrencyCovert(iso_currency).props.children}{pricePerNight} ({dormOrRoomAmount} {pluralHelper(dormOrRoomText, dormOrRoomAmount)}) x {nights} {pluralHelper('night', nights)}
                                    </p> 
                                )
                            }

                        </div>

                        {   
                            hotelLoading && (
                                <div className="mt3">
                                    <Spinner  />
                                    <SpinnerText text="Loading hotels..." loadClass="center f-size-14 mt2" />
                                </div>
                            )
                        }
                        {
                            (accommodation.hotelRooms.length === 0 && !hotelLoading) && (
                                <>
                                <p className="bold mb1 mt3">Hotel</p>
                                <p className="mb1 f-size-14 agent-portal-grey">No hotel rooms available for chosen days</p>
                                </>
                            )
                        }
                        { 
                        (accommodation.hotelRooms.length > 0 && !hotelLoading) && (
                            <>
                                <p className="bold mb1 mt3">Hotel</p>
                                <p className="mb1 f-size-14">{accommodation.hotelName}</p>

                                <div className="select-wrapper">
                                    <div className={`busabout-radio radio margin-b-10 arrow`}>
                                        <input
                                            id={`hotelAccommodationCard`}
                                            name={`hotelAccommodationCard`}
                                            type="radio"
                                            value="hotel"
                                            checked={accommodationType === "hotel"}
                                            readOnly
                                        />
                                        <label htmlFor={`hotelAccommodationCard`} className="radio-label">{hotelOption === "" ? 'Choose room type' : hotelMessage }</label>
                                    </div>     
                            
            
                                    <form className="form round-corners white-background">
                                        <select 
                                                name="hotel_accommodation"
                                                value={hotelOption} 
                                                onChange={this.handleHotelAccommodation}
                                                className={`busabout-selectdropdown x-small outline round-corners ${accommodationType === "hotel" ? 'hotel' : ''}`}> 
                                            >
                                            <option value="" disabled>Choose room type</option>

                                            { accommodation.hotelRooms.map(item => (
                                                <option 
                                                    key={item.roomCode} 
                                                    value={item.roomCode} 
                                                    data-roomcode={item.roomCode} 
                                                    data-roomtype={item.type} 
                                                    data-message={`${item.description} - ${ISOCurrencyCovert(iso_currency).props.children}${calculateBedOrRoomTotal(item.type, passengers.length, item.price, data.nights)}`}>
                                                    {item.description} - {ISOCurrencyCovert(iso_currency).props.children}{calculateBedOrRoomTotal(item.type, passengers.length, item.price, data.nights)}
                                                </option>)
                                            )
                                            }
                                        </select>
                                    </form>
                                    { (accommodationType === 'hotel' && hotelMessage !== "") && <p className="green-text right-align f-size-14 medium">{ISOCurrencyCovert(iso_currency).props.children}{pricePerNight} ({rooms} {pluralHelper('room', rooms)}) x {nights} {pluralHelper('night', nights)}</p> }
                                </div>   
                            </>
                        )}

                    </div>  

                    <div className="no-accommodation">
                      
                        <div className={`busabout-radio radio last margin-b-20`} onClick={(e) => this.onAccommodationChange("none")}>
                            <input
                            id={`noAccommodationCard`}
                            name={`noAccommodationCard`}
                            type="radio"
                            value="none"
                            checked={accommodationType  === 'none'}
                            readOnly
                            />
                            <label htmlFor={`noAccommodationCard`} className="radio-label">  No thanks, I will book my own</label>
                        </div> 

                        <p className="f-size-12 medium center">Busabout hand picks accommodation partners based on strict requirements to ensure our customers get the best experience.</p>
                    </div>
                </div>

             

            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return{
      currentBooking:state.currentBooking,
      isLoading:state.cart.update_sector_loading,
      hotel:state.hotel.sector[0],
      hotelLoading:state.hotel.update_hotel_loading
    }
}
  
export default withApollo(connect(mapStateToProps, null)(AccommodationPanel)); 